import { combineReducers } from 'redux';
import { rootReducer as bookingProcess } from '@platform/booking-process';
import i18nReducer from './i18n';

const reducers = {
  booking: bookingProcess,
  i18n: i18nReducer,
};

const rootReducer = combineReducers(reducers);

export default rootReducer;
